module.exports = __webpack_public_path__ + "img/sony-f8775268.png";